<template>
  <div v-if="post" class="frisbuy-popup-overlay" @click.self="popupClose">
    <div v-if="!showComplainForm" class="frisbuy-popup-controls" :class="{'frisbuy-popup-controls-no-navigation': postList.length == 1}">
      <div class="frisbuy-popup-navigation" v-if="postList.length > 1">
        <div class="frisbuy-popup-control frisbuy-prev" @click="popupPrev">
            <svg viewBox="0 0 24 43">
                <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
                <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
            </svg>
        </div>
        <div class="frisbuy-popup-control frisbuy-next" @click="popupNext">
            <svg viewBox="0 0 24 43">
                <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
                <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
            </svg>
        </div>
      </div>
      <!-- <div class="frisbuy-popup-control frisbuy-close" @click="popupClose">
          <svg viewBox="0 0 26 26">
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "></path>
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(-1, -1) translate(-12.000000, -12.000000) "></path>
          </svg>
      </div> -->
    </div>

    <div :class="{
      'frisbuy-popup': true,
      'frisbuy-complain-show': showComplainForm,
      'frisbuy-has-share': popupSettings.shareButtons.enable}"
      >
      <div class="frisbuy-scroller">
        <div class="frisbuy-complain-form" :class="{'frisbuy-complain-message': complainSended}" v-if="showComplainForm" @touchemove.stop>
          <template v-if="complainSended">
            <div class="frisbuy-complain-form__title">{{ popupText.complainAccepted }}<br/> {{ popupText.afterAccept }}</div>
            <div class="frisbuy-complain-form__buttons">
              <button @click="showComplainForm = false">{{ popupText.ok }}</button>
            </div>
          </template>
          <template v-else>
            <div class="frisbuy-complain-form__title">{{ popupText.confirm }}</div>
            <div class="frisbuy-complain-form__note">{{ popupText.complainNote }}</div>
            <div class="frisbuy-complain-form__email" :class="{'frisbuy-error-message': inputErrorEmail}" @click="inputErrorEmail = false">
              <label>Email</label>
              <input type="email" @input="complainErrorEmail = null" v-model="email" placeholder="">
              <div class="frisbuy-complain-form__error" v-if="complainErrorEmail">
                {{complainErrorEmail}}
              </div>
            </div>
            <div class="frisbuy-complain-form__text" :class="{'frisbuy-error-message': inputErrorText}" @click="inputErrorText = false">
                <label>Текст жалобы</label>
                <textarea class="frisbuy-complain-form__textarea" cols="30" rows="1" v-model="complainText" @input="complainErrorText = null" placeholder=""></textarea>
                <div class="frisbuy-complain-form__error" v-if="complainErrorText">
                  {{complainErrorText}}
                </div>
            </div>
            <div class="frisbuy-complain-form__buttons">
              <button @click="showComplainForm = false" :disabled="inSending">{{ popupText.cancel }}</button>
              <button :class="{'frisbuy-button-loading': inSending}" @click="sendComplain" :disabled="inSending">{{ popupText.submit }}</button>
            </div>
          </template>

        </div>

        <button class="frisbuy-popup-close-button" @click="popupClose">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2.98139" height="20.8698" transform="matrix(-0.707735 0.706478 -0.707735 -0.706478 16.8804 14.8938)" fill="#333333"/>
            <rect width="2.98139" height="20.8698" transform="matrix(0.707735 0.706478 -0.707735 0.706478 14.8901 -1.52588e-05)" fill="#333333"/>
          </svg>        
        </button>

        <div v-touch:swipe="swipeHandler" class="frisbuy-content-wrapper frisbuy-scroller" ref="scrollWrapper" :style="swipeStyle">
          <div class="frisbuy-popup-content">
            <div class="frisbuy-popup-media">
              <div v-if="popupSettings.showReportButton && !isPlaying" class="frisbuy-complain-button" @click="showComplainForm = true">
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.79753 0.0286079C5.53223 0.0911624 5.27861 0.271445 5.08505 0.535087C5.00335 0.646357 0.986797 7.36038 0.301285 8.53157C0.0909552 8.89089 0.0188286 9.08942 0.0039888 9.34978C-0.00589645 9.52317 0.000796937 9.58208 0.0445541 9.7073C0.182852 10.103 0.531671 10.3225 1.1058 10.3752C1.46515 10.4083 10.5349 10.4083 10.8942 10.3752C11.4683 10.3225 11.8171 10.103 11.9554 9.7073C11.9992 9.58208 12.0059 9.52317 11.996 9.34978C11.9812 9.08942 11.909 8.89089 11.6987 8.53157C11.0132 7.36038 6.99665 0.646357 6.91495 0.535087C6.71488 0.262565 6.44843 0.0787991 6.17153 0.022334C6.0181 -0.00894327 5.9521 -0.00783608 5.79753 0.0286079ZM6.31235 2.75388C6.61243 2.85641 6.8275 3.12174 6.88353 3.4585C6.90887 3.61101 6.88834 3.79067 6.76245 4.51749C6.64688 5.1847 6.52899 5.93999 6.48886 6.2705C6.46804 6.44176 6.44553 6.61561 6.43881 6.65685L6.42659 6.73181H6.002H5.57739L5.56071 6.54152C5.52477 6.13169 5.39862 5.34 5.16468 4.05618C5.10028 3.70272 5.09399 3.63197 5.11412 3.48728C5.1699 3.08651 5.45214 2.78207 5.82688 2.71843C5.9616 2.69557 6.19058 2.71227 6.31235 2.75388ZM6.36921 7.33033C6.52399 7.40372 6.7291 7.59208 6.79835 7.72436C6.88631 7.89249 6.91766 8.09327 6.88376 8.27148C6.868 8.35426 6.83324 8.46353 6.80652 8.51427C6.73098 8.6576 6.5419 8.82513 6.3653 8.90517C6.22626 8.96816 6.18182 8.97688 6 8.97688C5.81818 8.97688 5.77374 8.96816 5.6347 8.90517C5.459 8.82554 5.26909 8.65774 5.19455 8.51628C5.1135 8.36245 5.08324 8.15657 5.11619 7.98334C5.15375 7.78599 5.23155 7.64377 5.37278 7.51434C5.59973 7.30631 5.71804 7.26166 6.02382 7.26867C6.2085 7.27291 6.27202 7.28424 6.36921 7.33033Z" fill="white"/>
                </svg>
                {{ popupText.complain }}
              </div>

              <post-image :media="currentMedia" :post="post" v-if="!isPlaying || !mediaIsVideo" :settings="settings" ref="postImage"></post-image>

              <div class="frisbuy-media-play" v-if="currentMedia.videoUrl && !isPlaying" @click="isPlaying = true">
                <img :src="`${envDomain}/images/widget/play.svg`">
              </div>

              <div :class="{ 'frisbuy-video-wrapper': isPlaying }" v-if="currentMedia.videoUrl" >
                <video
                  v-show="isPlaying"
                  :controls="isPlaying"
                  loop="true"
                  controlsList="nodownload"
                  :autoplay="popupSettings.autoplayVideo"
                  :muted="getSoundStatus()"
                  @loadeddata="videoLoaded"
                  ref="video"
                  @pause="pauseVideo"
                  playsinline
                  @volumechange="videoSoundHandler"
                >
                  <source @error="errorVideoHandler" type="video/mp4" />
                </video>
              </div>

              <div class="frisbuy-gallery-navigation" v-if="isMultiPosts">
                <div class="frisbuy-navigation-button" v-if="mediaIndex" @click="navigate(mediaIndex - 1)">
                  <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                    <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
                  </svg>
                </div>
                <span></span>
                <div class="frisbuy-navigation-button" v-if="mediaIndex !== post.media.length - 1" @click="navigate(mediaIndex + 1)">
                  <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                    <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
                  </svg>
                </div>
              </div>

            </div>

            <frisbuy-gallery-pagination v-if="isMultiPosts"
              :itemsCount="post.media.length"
              :currentItemIdx="mediaIndex"
              @navigateTo="(idx) => navigate(idx)"
            />
          </div>

          <div class="frisbuy-popup-details" :class="{'frisbuy-details-no-post-text': !post.frisbuyPost.text}">
            <div class="frisbuy-details-scroller frisbuy-scroller" ref="scrollDetails">
              <div class="frisbuy-post-details" :class="{'frisbuy-details-no-post-text': !post.frisbuyPost.text}">
                <div class="frisbuy-brand" :style="{'background-image': `url(${ post.instagramPost.authorUser.avatarUrl })`}"></div>
                <a
                  :href="popupSettings.enableAuthorLink ? post.instagramPost.postLink : undefined"
                  target="_blank"
                >
                  {{ post.instagramPost.authorUser.fio || `@${post.instagramPost.authorUser.username}` }}
                </a>
              </div>
              
              <div class="frisbuy-similar" v-if="currentMedia.similarGoods && currentMedia.similarGoods.length">
                <div class="frisbuy-similar-title">{{ popupText.similarGoods }}</div>
                <div class="frisbuy-products-wrapper">
                  <div class="frisbuy-gallery-navigation" >
                    <div class="frisbuy-navigation-button" v-if="canPrevProduct" @click="navigateProducts(-1)">
                      <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                        <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
                      </svg>
                    </div>
                    <span></span>
                    <div class="frisbuy-navigation-button" v-if="canNextProduct" @click="navigateProducts(1)">
                      <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                        <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
                      </svg>
                    </div>
                  </div>
                  <div class="frisbuy-products-list" ref="productList" @scroll="productsScrollHandler">
                    <a
                      v-for="(link, index) in currentMedia.similarGoods"
                      class="frisbuy-product-item"
                      @click="similarLinkClick($event, link, index)"
                      :href="link.vendorShopUrl"
                      :target="Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'"
                    >
                      <div class="frisbuy-product-image" :style="{'background-image': `url(${ link.imageUrl })`}">
                      </div>
                      <div
                        v-if="link.price"
                        class="frisbuy-product-price"
                        :class="{'frisbuy-no-discount': !link.priceOld}"
                      >
                        <span>
                          {{link.price}} {{popupSettings.currencySymbol || ""}}
                          <svg v-if="!popupSettings.currencySymbol" viewBox="0 0 510.127 510.127">
                            <path fill="currentColor" d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z"/>
                          </svg>
                        </span>
                        
                        <span v-if="link.priceOld" class="frisbuy-price-old">
                          {{link.priceOld}} {{popupSettings.currencySymbol || ""}}
                          <svg v-if="!popupSettings.currencySymbol" viewBox="0 0 510.127 510.127">
                            <path fill="currentColor" d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z"/>
                          </svg>
                        </span>
                      </div>

                      <span>
                        {{link.name}}
                      </span>
                      <button>{{popupSettings.skuLinkText || popupText.buy }}</button>
                    </a>
                  </div>
                </div>
              </div>

              
              <div
                class="frisbuy-post-text"
                :class="{'hidden': isHideMobilePopupText}"
                v-html="tageted(post.frisbuyPost.text)"
              ></div>

              <button
                v-if="post.frisbuyPost.text?.length > 0"
                class="frisbuy-post-text-showing-button"
                @click="isHideMobilePopupText = !isHideMobilePopupText"
              >
              <span v-if="isHideMobilePopupText">
                Читать полностью
              </span>
              <span v-else>Скрыть</span>
              </button>
              
                

              <div class="frisbuy-comments" v-if="post.instagramPost.commentList && post.instagramPost.commentList.length">
                <div v-for="commment in post.instagramPost.commentList">
                  <strong>{{commment.author.username}}</strong> <span v-html="tageted(commment.text)"></span>
                </div>
                <a>{{ popupText.loadMoreComments }}</a>
              </div>

              <div class="frisbuy-products-title" v-if="currentMedia.linkList?.length"><span>Показанные товары</span></div>
              <div :class="{'frisbuy-products-list': true, 'frisbuy-products-inline': !showSkuPics, 'frisbuy-has-link': hasLink }">
                
                <a
                  v-for="(link, index) in currentMedia.linkList"
                  class="frisbuy-product-item"
                  @click="linkClick($event, link, index)"
                  :href="!hideBuyButton(link) && link.link"
                  :target="Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'"
                  @mouseenter="mouseOver(link, true)"
                  @mouseleave="mouseOver(link, false)"
                >
                  <div v-if="showUnpinnedNumbers" :class="{'frisbuy-marker': true, 'frisbuy-marker-hover': link.hover }" :style="{ color: popupSettings.image.numberColor }">
                    <span>{{index+1}}</span>
                  </div>

                  <div class="frisbuy-product-image" :style="{'background-image': `url(${ link.sku.thumbUrl })`}">
                    <div class="frisbuy-similar-title" v-if="link.isSimilar">{{ popupText.similarGood }}</div>
                  </div>

                  <div class="frisbuy-product-texts">
                    <span class="frisbuy-product-title">
                      {{link.title}}
                    </span>

                    <div v-if="link.sku.price" class="frisbuy-product-price">
                      <span :class="{ 'frisbuy-has-discount': link.sku.priceOld }">
                        {{ `${link.sku.price.replace(/\s/g,'')} ${link.sku.currencySymbol || popupSettings.currencySymbol || "&#8381;"}` }}
                      </span>

                      <span class="frisbuy-product-discount-wrapper">
                        <span v-if="link.sku.priceOld"
                          class="frisbuy-product-percent">
                          -{{ getDiscountPercent(Number(link.sku.price.replace(/\s/g, '')), Number(link.sku.priceOld.replace(/\s/g, '')))}}%
                        </span>

                        <span class="frisbuy-price-old" v-if="link.sku.priceOld">
                          {{ `${link.sku.priceOld.replace(/\s/g,'')} ${link.sku.currencySymbol || popupSettings.currencySymbol || "&#8381;"}` }}
                        </span>
                      </span>
                    </div>

                    <span class="frisbuy-product-text-link">подробнее</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Modules
import axios from "axios";
// Components
import defaultPopup from "@/gallery/popup/popup.vue";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";

export default {
  mixins: [defaultPopup],

  data() {
    return {
      complainErrorEmail: false,
      inputErrorEmail:false,
      complainErrorText: false,
      inputErrorText: false,
      clientOverflowX: '',
      isHideMobilePopupText: true,
    };
  },

  methods: {
    videoSoundHandler(e) {
      setTimeout(() => {
        sessionStorage.setItem("frb_gallery_sound", !e.target.muted ? Number(e.target.volume) : 0);
      }, 0)
    },

    getDiscountPercent(withSale, withoutSale) {
      const sale = Math.round((1 - withSale / withoutSale) * 100);
      return sale;
    },

    sendComplain() {
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const { srcDomain, embedId } = this.settings;
      const { complainText, email, post } = this;

      this.complainErrorEmail = null;
      this.complainErrorText = null;
      this.reportError = false;

      const emailMessage = 'Невеный адрес эл. почты';
      const textMessage = 'Пожалуйста, заполните это поле.';

      if ((!emailReg.test(email)) && !complainText) {
        this.complainErrorEmail = 'Пожалуйста, заполните это поле.';
        this.complainErrorText = 'Пожалуйста, заполните это поле.';
        this.inputErrorEmail = true;
        this.inputErrorText = true;
        this.reportError = {
          email: true,
          text: true,
          emailMessage,
          textMessage
        };

        return;
      }

      if (!emailReg.test(email)) {
        this.complainErrorEmail = 'Пожалуйста, заполните это поле.';
        this.inputErrorEmail = true;
        this.reportError = {
          email: true,
          emailMessage
        };

        return;
      }

      if (!email && !complainText) {
        this.complainErrorEmail = 'Пожалуйста, заполните это поле.';
        this.complainErrorText = 'Пожалуйста, заполните это поле.';
        this.inputErrorEmail = true;
        this.inputErrorText = true;
        this.reportError = {
          email: true,
          text: true,
          emailMessage,
          textMessage
        };

        return;
      }

      if (!emailReg.test(email) && !complainText) {
        this.complainErrorEmail = 'Пожалуйста, заполните это поле.';
        this.complainErrorText = 'Пожалуйста, заполните это поле.';
        this.inputErrorEmail = true;
        this.inputErrorText = true;
        this.reportError = {
          email: true,
          text: true,
          emailMessage,
          textMessage
        };

        return;
      }


      if (!complainText) {
        this.complainErrorText = 'Пожалуйста, заполните это поле.';
        this.inputErrorText = true;
        this.reportError = {
          text: true,
          textMessage
        };

        return;
      }

      this.inSending = true;

      axios({
        url: DomainSubstitute(`${srcDomain}/fb/post/report`),
        method: 'post',
        data: {
          post_id: post.frisbuyPost.id,
          embed_id: embedId,
          description: complainText,
          email
        }
      })
        .then(({ data }) => {
          const { request } = data;

          if (!request.success) {
            this.complainErrorEmail = request.error || request.statusMessage;
            this.complainErrorText = request.error || request.statusMessage;
            return;
          }

          this.complainSended = true;
        })
        .catch(({ response }) => {
          if (response) {
            this.complainErrorEmail = response.data.request.error;
            this.complainErrorText = response.data.request.error;
          } else {
            this.complainErrorEmail = error.message;
            this.complainErrorText = error.message;
          }
        })
        .finally(() => {
          this.inSending = false;
        });
      },

    autosizeTextAreaHeight(el) {
      el.style.height = "auto";

      this.$nextTick(() => {
        el.style.height = el.scrollHeight + "px";
      });
    },

    getSoundStatus() {
      const gallerySound = sessionStorage.getItem("frb_gallery_sound");
      if (gallerySound !== null) {
        if (this.$refs.video) {
          this.$refs.video.volume = Number(gallerySound);
        }

        return !Number(gallerySound);
      }
      return this.popupSettings.isVideoMuted;
    },
  },

  watch: {
    complainText() {
      const complainFormTextArea = document.querySelector(".frisbuy-complain-form__textarea");

      if (!complainFormTextArea) return;

      this.autosizeTextAreaHeight(complainFormTextArea);
    },

    showComplainForm(value) {
      if (value) return;
      this.complainErrorEmail = false;
      this.complainErrorText = false;
      this.email = '';
      this.complainText = '';
      this.inSending = false;
      this.complainSended = false;
    },
  },
};
</script>
